export const SSG_REVALIDATE_RATE_SEC = 10

export const API_BASE_URL = {
  API: '/api',
}

export const GEO_FALLBACK_CLIENT_IP = '0.0.0.0'

const DEFAULT_BYDB_US_MARKET_HOSTS = [
  'buildyourdreamsetup.taylormadegolf.com',
]

export const BYDB_US_MARKET_HOSTS = Array.from(
  new Set([
    ...DEFAULT_BYDB_US_MARKET_HOSTS,
    ...(
      process.env.NEXT_PUBLIC_BYDB_US_MARKET_HOSTS ??
      process.env.BYDB_US_MARKET_HOSTS ??
      ''
    )
      .split(',')
      .map((host) => host.trim().toLowerCase())
      .filter(Boolean),
  ]),
)

export const ROUTER_REQUIRED_QUERY_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
]

export const SENTRY_TRACE_SAMPLE_RATE = 0.1
export const SENTRY_REPLAY_SAMPLE_RATE = 0.1
export const SENTRY_ERROR_SAMPLE_RATE = 1.0

export const STORAGE_KEYS = {
  BYDB: {
    SELECTION: 'bydb-selection',
    SURVEY_TYPE: 'bydb-survey-type',
    EMAIL: 'bydb-email',
    SESSION_ID: 'bydb-session-id',
  },
  SPINTOWIN: {
    ENTRY_ID: 'spintowin-entry-id',
    PRIZE: 'spintowin-prize',
  },
}

/**
 * Responsive breakpoints in _pixels_ for <a href="https://theme-ui.com/" target="_blank" >ThemeUI Theme</a>.
 * Used in conjunction with [MEDIA](./Constants#.MEDIA) object and it is not recommended to use this object directly.
 */
export const BREAKPOINTS = {
  SM: 450,
  MD: 768,
  MD_PLUS: 800,
  LG: 1024,
  XL: 1200,
}

/**
 * Drop-in responsive media queries for `CSS-in-JS` style.
 */
export const MEDIA = {
  MIN_SM: `@media (min-width: ${BREAKPOINTS.SM}px)`,
  MAX_SM: `@media (max-width: ${BREAKPOINTS.SM - 1}px)`,
  MIN_MD: `@media (min-width: ${BREAKPOINTS.MD}px)`,
  MAX_MD: `@media (max-width: ${BREAKPOINTS.MD - 1}px)`,
  MD: `@media (min-width: ${BREAKPOINTS.MD}px) and (max-width: ${BREAKPOINTS.LG - 1}px)`,
  LG: `@media (min-width: ${BREAKPOINTS.LG}px) and (max-width: ${BREAKPOINTS.XL - 1}px)`,
  MIN_LG: `@media (min-width: ${BREAKPOINTS.LG}px)`,
  MAX_LG: `@media (max-width: ${BREAKPOINTS.LG}px)`,
  MIN_XL: `@media (min-width: ${BREAKPOINTS.XL - 1}px)`,
  MAX_XL: `@media (max-width: ${BREAKPOINTS.XL - 1}px)`,
  MIN_HEIGHT: (height: string | number) =>
    `@media (min-height: ${Number(height)}px)`,
  MAX_HEIGHT: (height: string | number) =>
    `@media (max-height: ${Number(height)}px)`,
}
